// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2279":"a5231038","2550":"9ec0f7b1","2845":"a5231038","9238":"a5231038"}[chunkId] + ".chunk.css");